/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Receipt_One_Seat_AddedInputs */



/**
* | output |
* | --- |
* | "+1 seat from {date}" |
*
* @param {Receipt_One_Seat_AddedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_one_seat_added = /** @type {((inputs: Receipt_One_Seat_AddedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_One_Seat_AddedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`+1 Platz ab ${i?.date}`)
	return /** @type {LocalizedString} */ (`+1 seat from ${i?.date}`)
});